const runtimeEnv = (window as unknown as { __ENV__?: Record<string, string> })
  .__ENV__;

export const config = {
  apiUrl: runtimeEnv?.VITE_API_URL || import.meta.env.VITE_API_URL || "",
  ldClientId:
    runtimeEnv?.VITE_LAUNCHDARKLY_CLIENT_ID ||
    import.meta.env.VITE_LAUNCHDARKLY_CLIENT_ID ||
    "",
  // Which deployment this build is running as, sent on every Amplitude event.
  // Falls back to the Vite mode so a local build is never unlabelled.
  environment:
    runtimeEnv?.VITE_ENVIRONMENT ||
    import.meta.env.VITE_ENVIRONMENT ||
    import.meta.env.MODE,
  // One write key per Amplitude project. Which of the two an event goes to is
  // the server's decision, handed over as `analyticsDestination` on
  // `GET /user/` (MS-3413)
  amplitudeApiKeyProd:
    runtimeEnv?.VITE_AMPLITUDE_API_KEY_PROD ||
    import.meta.env.VITE_AMPLITUDE_API_KEY_PROD ||
    "",
  amplitudeApiKeyQa:
    runtimeEnv?.VITE_AMPLITUDE_API_KEY_QA ||
    import.meta.env.VITE_AMPLITUDE_API_KEY_QA ||
    "",
  // The git SHA this bundle was built from, sent as Amplitude's `appVersion`.
  // Build-time only, unlike the values above: a version describes the bundle,
  // so a runtime value could name a build that is not the one running. Empty
  // for a local build.
  appVersion: import.meta.env.VITE_APP_VERSION || "",
  // Comma-separated Optro domain suffixes offered by the sign-in dialog. Unset
  // falls back to the production pair; see lib/optroDomain.ts.
  optroDomainSuffixes:
    runtimeEnv?.VITE_OPTRO_DOMAIN_SUFFIXES ||
    import.meta.env.VITE_OPTRO_DOMAIN_SUFFIXES ||
    "",
};
